module.exports = __webpack_public_path__ + "img/menu-img.52efe6b7.jpg";